var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isTunnelView)?_c('Breakpoints',[_c('MobilePageHeader',{attrs:{"slot":"max-sm"},slot:"max-sm"}),_c('DesktopPageHeader',{attrs:{"slot":"min-md"},slot:"min-md"})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }